import React from 'react';
import { NotificationHeaderProps } from './types';

export const NotificationHeader: React.FC<NotificationHeaderProps> = ({
  hasNotifications,
  onMarkAllAsRead,
  unreadCount = 0
}) => {
  return (
    <div className="flex items-start justify-between gap-3 border-b border-[rgba(var(--f-ink-rgb),0.08)] px-5 pt-[18px] pb-3.5">
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="frost-mono text-fs-10 font-semibold uppercase leading-[1.35] tracking-[0.22em] text-frost-ink-whisper">
          Tu bandeja
        </span>
        <div className="flex items-center gap-2">
          <h2 className="text-fs-16 font-bold leading-[1.35] tracking-[-0.01em] text-frost-ink">
            Notificaciones
            <span className="text-frost-brand">.</span>
          </h2>
          {unreadCount > 0 && (
            <span className="frost-mono inline-flex h-[18px] min-w-[22px] items-center justify-center rounded-full bg-frost-brand px-1.5 text-fs-10 font-semibold tabular-nums text-white">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </div>
      </div>
      {hasNotifications && unreadCount > 0 && (
        <button
          type="button"
          onClick={onMarkAllAsRead}
          className="inline-flex h-8 items-center rounded-lg border border-frost-hair-strong bg-frost-card px-2.5 text-fs-11-5 font-semibold text-frost-ink-soft transition-colors hover:border-frost-brand/30 hover:bg-frost-brand-wash hover:text-frost-brand"
        >
          Marcar todas
        </button>
      )}
    </div>
  );
};
